// extracted by mini-css-extract-plugin
export default {"outlet":"dashboard_outlet__KvjJL","title":"dashboard_title__z5nT6"};